/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { createSlice } from "@reduxjs/toolkit";
import { rolesState } from "./roles.state";

const roles = createSlice({
    name: "roles",

    initialState: rolesState,

    reducers: {
        setRoles (state, action) {
            state.all = action.payload;
        },
        // setRoleItem(state, action) {
        //     const role = action.payload
        //     const guid = role.guid
        //     state.byGUID[guid] = role
        //     state.current = role
        // },
    },
});

export const rolesReducer = roles.reducer;

export const {
    // setRoleItem,
    setRoles
} = roles.actions;
